import { render } from "./ViewsAuthLogout.vue?vue&type=template&id=25a6d6b3"
import script from "./ViewsAuthLogout.vue?vue&type=script&lang=js"
export * from "./ViewsAuthLogout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__